<ng-container *ngIf="!(initialized$ | async)">
	<app-login-form class="initialize-class"></app-login-form>
	<lib-progress-spinner class="login-spinner"></lib-progress-spinner>
</ng-container>

<app-login-form *ngIf="(initialized$ | async) && !(authorized$ | async)"></app-login-form>



<ng-container *ngIf="authorized$ | async">

	<app-ac-system-header></app-ac-system-header>

	<div class="content-to-show">
		<router-outlet></router-outlet>
	</div>

	<div class="offline-message-block" *ngIf="!(online$ | async) && !dev">
		<div class="offline-message">
			Check Internet Connection
		</div>
	</div>
</ng-container>

